import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

export const exportToExcel = async (
    data,
    userDetails,
    employeeId,
    fromDate,
    toDate
) => {
    const workbook = new ExcelJS.Workbook();


    const worksheet = workbook.addWorksheet("Form B");

    worksheet.pageSetup = {
        paperSize: 9,
        // orientation: "landscape",
        orientation: "portrait",
        fitToPage: true,
        fitToWidth: 1,
        fitToHeight: 0
    };

    worksheet.properties.defaultRowHeight = 22;
    worksheet.columns = [
        // { width: 8 },
        { width: 18 },
        { width: 18 },
        { width: 14 },
        { width: 18 },
        { width: 14 },
        { width: 18 },
        { width: 18 },
        { width: 35 }
    ];


    worksheet.mergeCells("A1:H1");
    worksheet.getRow(1).height = 25;
    const title = worksheet.getCell("A1");
    title.value = "FORM B - ATTENDANCE RECORD";
    title.font = {
        name: "Calibri",
        size: 16,
        bold: true,
    };
    title.alignment = {
        horizontal: "center",
        vertical: "middle"
    };

    worksheet.mergeCells("A2:H2");
    worksheet.getCell("A2").value = "for";
    worksheet.getCell("A2").font = {
        bold: false,
        size: 10
    };
    worksheet.getCell("A2").alignment = {
        horizontal: "center"
    };



    worksheet.mergeCells("A3:H3");
    worksheet.getCell("A3").value = `${userDetails.firstName} ${userDetails.lastName}`;
    worksheet.getCell("A3").font = {
        bold: false,
        size: 10
    };
    worksheet.getCell("A3").alignment = {
        horizontal: "center"
    };



    worksheet.mergeCells("A4:H4");
    worksheet.getCell("A4").value = "(Name of Security Officer)";
    worksheet.getCell("A4").font = {
        bold: false,
        size: 10,
    };
    worksheet.getCell("A4").alignment = {
        horizontal: "center"
    };
    worksheet.getCell("A4").border = {

        bottom: { style: "thin" }

    };



    worksheet.mergeCells("A5:H5");
    const ins = worksheet.getCell("A5");
    ins.value = "INSTRUCTIONS";
    ins.font = {
        bold: true
    };
    // ins.fill = {
    //     type: "pattern",
    //     pattern: "solid",
    //     fgColor: {
    //         argb: "FFFF00"
    //     }
    // };
    ins.alignment = {
        horizontal: "left"
    };


    const instructions = [
        "1. Please complete Form B by providing the attendance records which matches the salary period of the security officer for the most recent complete month.",
        "2. If your security officer's salary period is from 01 Sep 2021 to 30 Sep 2021, please provide attendance records for Sep 2021.",
        "3. If your security officer's salary period is from 16 Aug 2021 to 15 Sep 2021, please provide attendance records for Aug 2021 and Sep 2021.",
        "4. Please do not leave any fields empty. In the event you have selected 'Others' under the Remarks column, please state the reason(s) in the next column.",
        "5. Please refer to the remarks available in the legend at the bottom of the page.",
        "6. Please select the Public Holiday entitlement given to your security officer. ",
    ];

    let row = 6;

    instructions.forEach(text => {

        worksheet.mergeCells(`A${row}:H${row}`);

        worksheet.getCell(`A${row}`).value = text;

        worksheet.getCell(`A${row}`).alignment = {
            wrapText: false
        };

        row++;

    });

    // row += 2;

    // worksheet.getCell(`A${row}`).value = "Employee";

    // worksheet.getCell(`B${row}`).value =
    //     `${userDetails.firstName} ${userDetails.lastName}`;

    // worksheet.getCell(`D${row}`).value = "Employee ID";

    // worksheet.getCell(`E${row}`).value = employeeId;

    // worksheet.getCell(`G${row}`).value = "Designation";

    // worksheet.getCell(`H${row}`).value =
    //     userDetails.roleName;

    // row++;

    // worksheet.getCell(`A${row}`).value = "Period";

    // worksheet.getCell(`B${row}`).value =
    //     `${fromDate} To ${toDate}`;



    // row += 2;

    const headerRow = worksheet.getRow(row);
    headerRow.values = [
        // "S.No",
        "Day",
        "Date In",
        "Time In",
        "Date Out",
        "Time Out",
        "Break (Hr)",
        "Remarks",
        "Other Reason"
    ];
    headerRow.height = 28;
    headerRow.eachCell((cell) => {
        cell.font = {
            bold: true,
            color: { argb: "FFFFFFFF" }
        };

        cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "4472C4" }
        };

        cell.alignment = {
            horizontal: "center",
            vertical: "middle",
            wrapText: true
        };

        cell.border = {
            top: { style: "thin" },
            bottom: { style: "thin" },
            left: { style: "thin" },
            right: { style: "thin" }
        };

    });


    // let weekNo = 1;
    // let lastWeek = null;
    data.forEach((d, index) => {

        const date = new Date(d.dateIn);

        const week = Math.ceil(date.getDate() / 7);

        // if (week !== lastWeek) {

        //     row++;

        //     worksheet.mergeCells(`A${row}:I${row}`);

        //     const wk = worksheet.getCell(`A${row}`);

        //     wk.value = `WEEK ${weekNo}`;

        //     wk.font = {
        //         bold: true,
        //         size: 12
        //     };

        //     wk.alignment = {
        //         horizontal: "center"
        //     };

        //     wk.fill = {
        //         type: "pattern",
        //         pattern: "solid",
        //         fgColor: {
        //             argb: "D9EAD3"
        //         }
        //     };

        //     wk.border = {
        //         top: { style: "thin" },
        //         bottom: { style: "thin" },
        //         left: { style: "thin" },
        //         right: { style: "thin" }
        //     };

        //     lastWeek = week;

        //     weekNo++;

        // }

        row++;

        worksheet.addRow([
            // index + 1,
            d.day,
            d.dateIn,
            d.timeIn || "-",
            d.dateOut,
            d.timeOut || "-",
            d.breakHours || "-",
            d.timeSheetRemark?.remarks || "",
            d.otherReason || d.timeSheetRemark?.otherReason || ""
        ]);

        row++;

        // // worksheet.getCell(`A${row}`).value = index + 1;
        // worksheet.getCell(`B${row}`).value = d.day;
        // worksheet.getCell(`C${row}`).value = d.dateIn;
        // worksheet.getCell(`D${row}`).value = d.timeIn || "-";
        // worksheet.getCell(`E${row}`).value = d.dateOut;
        // worksheet.getCell(`F${row}`).value = d.timeOut || "-";
        // worksheet.getCell(`G${row}`).value = d.breakHours || "-";
        // worksheet.getCell(`H${row}`).value = d.timeSheetRemark?.remarks || "";
        // worksheet.getCell(`I${row}`).value =
        //     d.otherReason || d.timeSheetRemark?.otherReason || "";
    });

    // Table mudinja current last row
    row = worksheet.lastRow.number;



    worksheet.eachRow((row, rowNumber) => {
        if (rowNumber >= 12) {
            row.eachCell(cell => {
                cell.border = {
                    top: { style: "thin" },
                    bottom: { style: "thin" },
                    left: { style: "thin" },
                    right: { style: "thin" }
                };

                cell.alignment = {
                    horizontal: "center",
                    vertical: "middle",
                    wrapText: true
                };
            });
        }
    });



    worksheet.eachRow((row, rowNumber) => {
        if (rowNumber > 12 && rowNumber % 2 === 0) {
            row.eachCell(cell => {
                cell.fill = {
                    type: "pattern",
                    pattern: "solid",
                    fgColor: { argb: "F7F7F7" }
                };
            });
        }
    });


    row += 2;
    worksheet.mergeCells(`A${row}:B${row}`);
    worksheet.mergeCells(`C${row}:C${row}`);
    worksheet.mergeCells(`D${row}:D${row}`);
    worksheet.mergeCells(`F${row}:G${row}`);
    worksheet.mergeCells(`H${row}:H${row}`);

    worksheet.getCell(`A${row}`).value = "Total OverTime Hours Performed";
    worksheet.getCell(`C${row}`).value = "0";
    worksheet.getCell(`D${row}`).value = "hours";
    worksheet.getCell(`F${row}`).value = "Public Holiday Entitlement";
    worksheet.getCell(`H${row}`).value = "off in lue";

    // Salary Period
    row += 2;
    worksheet.getCell(`A${row}`).value = "Salary Period";
    worksheet.getCell(`B${row}`).value = "01-MAY-2026";
    worksheet.getCell(`C${row}`).value = "to";
    worksheet.getCell(`D${row}`).value = "31-MAY-2026";

    // Date Style
    ["B", "D"].forEach(col => {
        const cell = worksheet.getCell(`${col}${row}`);

        cell.font = {
            bold: true,
            color: { argb: "1F4E78" }
        };

        cell.alignment = {
            horizontal: "center"
        };

        cell.border = {
            bottom: {
                style: "thin"
            }
        };
    });


    // Date Format Row
    row++;

    worksheet.getCell(`B${row}`).value = "DD-MM-YYYY";
    worksheet.getCell(`D${row}`).value = "DD-MM-YYYY";

    ["B", "D"].forEach(col => {
        const cell = worksheet.getCell(`${col}${row}`);

        cell.font = {
            italic: true,
            color: { argb: "808080" },
            size: 9
        };

        cell.alignment = {
            horizontal: "center"
        };
    });


    //overtime salary period
    row += 2;

    worksheet.mergeCells(`A${row}:B${row}`);
    worksheet.getCell(`A${row}`).value = "Overtime Salary Period";

    worksheet.getCell(`C${row}`).value = "01-MAY-2026";
    worksheet.getCell(`D${row}`).value = "to";
    worksheet.getCell(`E${row}`).value = "31-MAY-2026";

    ["C", "E"].forEach(col => {
        const cell = worksheet.getCell(`${col}${row}`);

        cell.font = {
            bold: true,
            color: { argb: "1F4E78" }
        };

        cell.alignment = {
            horizontal: "center"
        };

        cell.border = {
            bottom: {
                style: "thin"
            }
        };
    });

    row++;

    worksheet.getCell(`C${row}`).value = "DD-MM-YYYY";
    worksheet.getCell(`E${row}`).value = "DD-MM-YYYY";

    ["C", "E"].forEach(col => {
        const cell = worksheet.getCell(`${col}${row}`);

        cell.font = {
            italic: true,
            size: 9,
            color: { argb: "808080" }
        };

        cell.alignment = {
            horizontal: "center"
        };
    });


    row += 2;

    worksheet.mergeCells(`A${row}:H${row}`);

    const legendTitle = worksheet.getCell(`A${row}`);

    legendTitle.value = "LEGEND";

    legendTitle.font = {
        bold: true,
        size: 13,
        underline: true
    };

    // legendTitle.fill = {
    //     type: "pattern",
    //     pattern: "solid",
    //     fgColor: {
    //         argb: "FFD966"
    //     }
    // };

    legendTitle.alignment = {
        horizontal: "left"
    };

    row++;

    const legends = [
        [
            "RD - Rest Day",
            "WRD - Work On Rest Day",
            "NRD - Non Working Day",
            "WNRD - Work On Non Working Day"
        ],
        [
            "AL - Annual Leave",
            "UPL - Unpaid Leave",
            "SL - Sick Leave",
            "ML - Maternity Leave"
        ],
        [
            "AWOL - Absent Without Official Leave",
            "OC - On Course Including ICT Training",
            "PH - Public Holiday Off",
            "OIL (PH) - Off-in-lieu for Public Holiday"
        ],
        [
            "Others - eg. Compassionate Leave"
        ]
    ];

    legends.forEach((item) => {

        worksheet.mergeCells(`A${row}:B${row}`);
        worksheet.mergeCells(`C${row}:D${row}`);
        worksheet.mergeCells(`E${row}:F${row}`);
        worksheet.mergeCells(`G${row}:H${row}`);

        worksheet.getCell(`A${row}`).value = item[0] || "";
        worksheet.getCell(`C${row}`).value = item[1] || "";
        worksheet.getCell(`E${row}`).value = item[2] || "";
        worksheet.getCell(`G${row}`).value = item[3] || "";

        ["A", "C", "E", "G"].forEach(col => {
            const cell = worksheet.getCell(`${col}${row}`);

            // cell.font = {
            //     bold: true,
            //     size: 10
            // };

            cell.alignment = {
                horizontal: "left",
                vertical: "middle",
                wrapText: true
            };

            // cell.border = {
            //     top: { style: "thin" },
            //     bottom: { style: "thin" },
            //     left: { style: "thin" },
            //     right: { style: "thin" }
            // };
        });

        row++;
    });

    // row += 2;
    // worksheet.mergeCells(`A${row}:I${row}`);
    // worksheet.getCell(`A${row}`).value =
    //     "I hereby declare that the above attendance records are true and correct.";
    // worksheet.getCell(`A${row}`).alignment = {
    //     wrapText: true
    // };



    // row += 3;
    // worksheet.mergeCells(`A${row}:C${row}`);
    // worksheet.mergeCells(`D${row}:F${row}`);
    // worksheet.mergeCells(`G${row}:I${row}`);

    // worksheet.getCell(`A${row}`).value = "Prepared By";
    // worksheet.getCell(`D${row}`).value = "Checked By";
    // worksheet.getCell(`G${row}`).value = "Approved By";

    // worksheet.getRow(row).font = {
    //     bold: true
    // };

    // row += 4;
    // worksheet.mergeCells(`A${row}:C${row}`);
    // worksheet.mergeCells(`D${row}:F${row}`);
    // worksheet.mergeCells(`G${row}:I${row}`);

    // worksheet.getCell(`A${row}`).value =
    //     "__________________";

    // worksheet.getCell(`D${row}`).value =
    //     "__________________";

    // worksheet.getCell(`G${row}`).value =
    //     "__________________";


    // worksheet.views = [
    //     {
    //         state: "frozen",
    //         ySplit: 12
    //     }
    // ];



    // worksheet.autoFilter = {
    //     from: "A12",
    //     to: "I12"
    // };


    worksheet.pageSetup.printArea = `A1:I${row}`;


    worksheet.headerFooter.oddFooter =
        "&LGenerated By TimeSheet System&CPage &P of &N&R" +
        new Date().toLocaleDateString();


    const buffer = await workbook.xlsx.writeBuffer();

    saveAs(
        new Blob([buffer]),
        `${userDetails.firstName}_${userDetails.lastName}_Form_B.xlsx`
    );
}

